export default __webpack_public_path__ + "static/media/Logo.b6449360.png";